/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedDetailShipping_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfoLink_user" | "PdpSharedShippingInfo_user">;
    readonly " $refType": "PdpSharedDetailShipping_user";
};
export type PdpSharedDetailShipping_user$data = PdpSharedDetailShipping_user;
export type PdpSharedDetailShipping_user$key = {
    readonly " $data"?: PdpSharedDetailShipping_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailShipping_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailShipping_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoLink_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfo_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '513fac9a5114ab6725b967059eeb029b';
export default node;
